import React from "react"

function CaseDetail(){
    return <React.Fragment>
        <iframe title="RevVolCaseExtract" width="1400" height="800" src="https://app.powerbi.com/reportEmbed?reportId=99ca5ef6-42ce-422e-b299-583a355bca4e&autoAuth=true&ctid=49423d5d-8d49-4128-b53d-59537808f6ac" allowFullScreen={true}></iframe>
    </React.Fragment>
}

export{CaseDetail}